var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Store, Select, Actions, ofActionDispatched } from '@ngxs/store';
import { NextView, PreviousView } from '../../state/edit.actions';
import { Observable, Subject } from 'rxjs';
import { EngineState } from 'src/app/engine/state/engine.state';
import { filter, takeUntil } from 'rxjs/operators';
import { EditPaintState } from '../../state/paint/edit.paint.state';
import { ClickNode, SetActiveTool } from 'src/app/engine/state/engine.actions';
import { PaintService } from 'src/app/engine/paint.service';
import { ToolEnum } from 'src/app/engine/models/tool.enum';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { RecordChapterPaintState } from 'src/app/story/state/chapters/story.chapters.actions';
import { EngineNodesState } from 'src/app/engine/state/nodes/engine.nodes.state';
import { EditState } from '../../state/edit.state';
import { PaintPresetOriginal } from 'src/app/engine/models/paint-presets.const';
var EditPaintContextComponent = /** @class */ (function () {
    function EditPaintContextComponent(store, actions, paintService, changeDetector) {
        this.store = store;
        this.actions = actions;
        this.paintService = paintService;
        this.changeDetector = changeDetector;
        this.activeToolEnum = ToolEnum;
        this.ngUnsubscribe = new Subject();
    }
    EditPaintContextComponent.prototype.ngOnInit = function () {
        this.bindApplicationEvents();
    };
    EditPaintContextComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    EditPaintContextComponent.prototype.bindApplicationEvents = function () {
        var _this = this;
        // Listen for clicked node, ensure we're in paint mode
        this.actions
            .pipe(ofActionDispatched(ClickNode), filter(function (nodeAction) {
            return nodeAction.node != null &&
                _this.store.selectSnapshot(EngineState.getActiveTool) === ToolEnum.Paint &&
                !nodeAction.event.srcEvent.shiftKey;
        }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (clickNode) {
            // record and set interactive pick
            var colorRecipe = _this.store.selectSnapshot(EditPaintState.getColorRecipe);
            _this.paintNodes([clickNode.node], colorRecipe);
        });
        // Only show when model is loaded
        this.selectedChapter$
            .pipe(filter(function (chapter) { return chapter != null; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (chapter) {
            _this.interactive = chapter.readyState.model;
            _this.changeDetector.markForCheck();
        });
    };
    EditPaintContextComponent.prototype.handleClickTool = function (tool) {
        this.store.dispatch(new SetActiveTool(tool));
    };
    EditPaintContextComponent.prototype.handleClearChapterPaint = function () {
        var nodes = Object.values(this.store.selectSnapshot(EngineState.getViewGraph).nodes);
        var recipe = PaintPresetOriginal.recipe;
        this.paintNodes(nodes, recipe);
    };
    EditPaintContextComponent.prototype.handlePaintNodesClick = function () {
        var checked = this.store.selectSnapshot(EngineNodesState.getCheckedNodes);
        var recipe = this.store.selectSnapshot(EditPaintState.getColorRecipe);
        this.paintNodes(checked, recipe);
    };
    // paint and conditionally record
    EditPaintContextComponent.prototype.paintNodes = function (nodes, recipe) {
        var record = this.store.selectSnapshot(EditState.getRecord);
        // relay paint to engine
        this.paintService.paintAll(nodes, recipe);
        // record
        this.store.dispatch(new RecordChapterPaintState(nodes, recipe, record));
    };
    EditPaintContextComponent.prototype.handleNext = function () {
        this.store.dispatch(new NextView());
    };
    EditPaintContextComponent.prototype.handlePrevious = function () {
        this.store.dispatch(new PreviousView());
    };
    __decorate([
        Select(EngineState.getActiveTool),
        __metadata("design:type", Observable)
    ], EditPaintContextComponent.prototype, "activeTool$", void 0);
    __decorate([
        Select(EngineNodesState.getCheckedNodes),
        __metadata("design:type", Observable)
    ], EditPaintContextComponent.prototype, "checkedNodes$", void 0);
    __decorate([
        Select(EditPaintState.getColorRecipe),
        __metadata("design:type", Observable)
    ], EditPaintContextComponent.prototype, "colorRecipe$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapterId),
        __metadata("design:type", Observable)
    ], EditPaintContextComponent.prototype, "selectedChapterId$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapter),
        __metadata("design:type", Observable)
    ], EditPaintContextComponent.prototype, "selectedChapter$", void 0);
    return EditPaintContextComponent;
}());
export { EditPaintContextComponent };
